export const jsonData = [
  {
    key: "Home",
    title: "Home",
    content: [
      {
        key: "Menu",
        title: "Menu",
        content: [
          {
            key: "Trading",
            title: "Trading",
            content: [
              {
                key: "Home",
                title: "Home",
                content: []
              },

              {
                key: "Questwealth portfolios",
                title: "Questwealth portfolios",
                content: [
                  {
                    key: "Account",
                    title: "Account",
                    content: []
                  },
                  {
                    key: "Returns",
                    title: "Returns",
                    content: []
                  }
                ]
              },
              {
                key: "Account request",
                title: "Account request",
                content: [
                  {
                    key: "Account Request Successful",
                    title: "Account Request Successful",
                    content: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: "Settings",
        title: "Settings",
        content: [
          {
            key: "Settings1",
            title: "Settings1",
            content: []
          }
        ]
      }
    ]
  },
  {
    key: "Home1",
    title: "Home1",
    content: [
      {
        key: "Home2",
        title: "Home2",
        content: [
          {
            key: "Home3",
            title: "Home3",
            content: []
          }
        ]
      }
    ]
  }
];
